require('./logoutModal.scss');

// @ vendor
const { connect } = require('react-redux');
const React = require('react');
const PropTypes = require('prop-types');

// @ actions
const logoutActions = require('actions/logout');

// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');
const { toFirstUppercase } = require('utilities/stringHelper');

// @ constants
const {
    ACTION_EVENT_CLOSE_MODAL,
    LOGOUT_MODAL_EVENT,
    LOGOUT_MODAL_REENTER,
    ACTION_EVENT_VIEW,
} = require('constants/tagging');

// @ assets
const sessionExpiredIcon = require('assets/images/session-expired.svg');

class LogoutModal extends React.Component {

    constructor(props) {
        super(props);
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
        this.handleReEnterButtonClick = this.handleReEnterButtonClick.bind(this);
    }

    componentDidUpdate() {
        const { immLogout } = this.props;
        if (immLogout.get('isOpen')) {
            recordLink(
                window.utag_data.nombrePagina, 
                LOGOUT_MODAL_EVENT, 
                ACTION_EVENT_VIEW
            );
        }
    }

    handleCloseModdalFIOC = () => {
        window.location.href = '/myprofile/global/';
    }

    handleCloseButtonClick() {
        const { handleLogout, isFIOCMobile, isMigrationMobile } = this.props;
        recordLink(
            window.utag_data.nombrePagina, 
            LOGOUT_MODAL_EVENT, 
            ACTION_EVENT_CLOSE_MODAL
        );

        if (isFIOCMobile || isMigrationMobile) {
            this.handleCloseModdalFIOC();
        } else {
            handleLogout();
        }
    }

    handleReEnterButtonClick() {
        const { handleLogout, isFIOCMobile, isMigrationMobile } = this.props;
        recordLink(
            window.utag_data.nombrePagina, 
            LOGOUT_MODAL_EVENT, 
            LOGOUT_MODAL_REENTER
        );
        if (isFIOCMobile || isMigrationMobile) {
            this.handleCloseModdalFIOC();
        } else {
            handleLogout();
        }
    }

    render() {
        const {
            acceptText,
            domainLanguage,
            immLogout,
            message,
            isFIOCMobile,
            isMigrationMobile
        } = this.props;
        const isOpen = immLogout.get('isOpen');
        const formattedMessage = formatText(message, null, domainLanguage);
        const btnText = toFirstUppercase(formatText(acceptText, null, domainLanguage));
        const overlayClassName = 'logout-modal__overlay'; 
        const overlayBackgroundClassName = `${isFIOCMobile || isMigrationMobile ? 'logout-modal__overlay--fioc-mobile' : ''}`
        const description = formatText('login-loginExpiredDescription', null, domainLanguage);
        const content = (
            <React.Fragment>
                <div className="logout-modal__content-icon">
                    <img src={sessionExpiredIcon}/>
                </div>
                <div className="logout-modal__description">
                    {description}
                </div>
            </React.Fragment>
        );
        const primaryButton = (
            <OKButton
                onClick={this.handleReEnterButtonClick}
                block={true}
            > 
                {btnText}
            </OKButton>
        );
        return (
            <OKModal
                shouldCloseOnOverlayClick={false}
                isOpen={isOpen}
                footerType="navigation"
                primaryButtonCustom={primaryButton}
                title={formattedMessage}
                onCloseCallback={this.handleCloseButtonClick}
                overlayClassName={overlayClassName}
                overlayBackgroundClassName={overlayBackgroundClassName}
                contentOverflow="auto"
                content={content}
            >
            </OKModal>
        );
    }
}

LogoutModal.propTypes = {
    message: PropTypes.string.isRequired,
    acceptText: PropTypes.string.isRequired,
    immLogout: PropTypes.object.isRequired,
    handleLogout: PropTypes.func.isRequired,
    domainLanguage: PropTypes.string.isRequired,
    isFIOCMobile: PropTypes.bool,
    isMigrationMobile: PropTypes.bool
};

LogoutModal.defaultProps = {
    isFIOCMobile: false,
    isMigrationMobile: false
}

module.exports.constructor = LogoutModal;
module.exports.LogoutModal = connect(
    state => ({
        immLogout: state.logout
    }),
    {
        handleLogout: logoutActions.handleLogout,
    }
)(LogoutModal);
